import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { countryCode } from 'Helpers/Geo/data';
import CountdownTimer from 'Components/Utility/CountdownTimer/CountdownTimer';

export default function OrderItemPreorderMessage({ game }) {
  const [preorderPassed, setPreorderPassed] = useState(false);

  let message;
  let countdown;

  const formatExactDate = (date, useTime) => {
    // When formattedDate is used it converts the preorder date to local time,
    // We don't want to do that in this scenario as the release date and time
    // is fixed at the date on the item
    const locale = `${window.locale || 'en'}-${countryCode || 'GB'}`;
    const d = new Date(date);
    let text = d.toLocaleDateString(locale);
    if (useTime) {
      text += ` ${d.toLocaleTimeString(locale, { timeZoneName: 'long' })}`;
    }

    // If the pre-order passes we no longer want to show the message
    if (Date.now() > Date.parse(date)) setPreorderPassed(true);

    return text;
  };

  if (preorderPassed) return false;

  if (game.preorder_pending && game.preorderPlayableFrom) {
    message = <FormattedMessage
      id="order-item.preorderEarlyAccessDate"
      defaultMessage="You'll get Early Access with this pre-order product on or before {date}. We will send you an email as soon as we have the key in stock and you'll be able to find it here."
      values={{
        date: formatExactDate(game.preorderPlayableFrom),
      }}
    />;
  } else if (game.preorder_pending && game.preorder_date) {
    message = <FormattedMessage
      id="order-item.preorderPendingDate"
      defaultMessage="This preorder product will be available on or before the release date ({date}). We will send you an email as soon as we have it in stock and you can find it here."
      values={{
        date: formatExactDate(game.preorder_date),
      }}
    />;
  } else if (game.ztormId && (game.preorderPlayableFrom || game.preorder_date)) {
    message = <FormattedMessage
      id="order-item.preorderPendingZtorm"
      defaultMessage="This preorder product will be ready to download keys on the release date ({date})."
      values={{
        date: formatExactDate(game.preorderPlayableFrom || game.preorder_date, true),
      }}
    />;
  } else if (game.preorderKeyTime && !game.preorder_pending) {
    message = <FormattedMessage
      id="order-item.preorderKeyTime"
      defaultMessage="We have your key, you'll be able to reveal it on {date}"
      values={{
        date: formatExactDate(game.preorderKeyTime, true),
      }}
    />;

    countdown = <FormattedMessage
      id="order-item.preorderKeyTimeCountdown"
      defaultMessage="Key reveal available in {countdown}"
      values={{
        countdown: <CountdownTimer daysText value={new Date(game.preorderKeyTime).valueOf()} />,
      }}
    />;
  } else if (game.preorder_pending) {
    message = <FormattedMessage
      id="order-item.bundleKeysPending"
      defaultMessage="Thank you for purchasing this game. We will provide you with your key as soon as it arrives and you will be notified via email."
    />;
  }

  if (!message) return false;

  return (
    <React.Fragment>
      <div className="w-100">{message}</div>
      {countdown &&
        <div className="w-100">{countdown}</div>
      }
    </React.Fragment>
  );
}

OrderItemPreorderMessage.propTypes = {
  game: PropTypes.shape({}),
};

OrderItemPreorderMessage.defaultProps = {
  game: null,
};
